var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCollapseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10L10.2929 11.2929C10.6834 11.6834 10.6834 12.3166 10.2929 12.7071L9 14M10 12L2 12M18 20C20.2091 20 22 18.2091 22 16V8C22 5.79086 20.2091 4 18 4M18 20C15.7909 20 14 18.2091 14 16V8C14 5.79086 15.7909 4 18 4M18 20H10C7.79086 20 6 18.2091 6 16M18 4H10C7.79086 4 6 5.79086 6 8",
    stroke: "#28303F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollapseRight);
export default __webpack_public_path__ + "static/media/icon-collapse-right.0e8631847c09d7931fabb0a831e558fa.svg";
export { ForwardRef as ReactComponent };